const groups = (state = [], action) => {
    switch (action.type) {
      case 'GROUP':
      return {
          type: "GROUP",
          groups: action.groups
        }
        case 'EDIT_GROUP':
              var exist = false
              state.groups.map(group => {
                if(group.id === action.id)
                   exist = true;
              })
             if(exist == false && action.name !== 'Received: INFO'){
               state.groups.push({id: action.id, name:  action.name})
              }


      default:
        return state
    }
  }
  
  export default groups